import React, { Component } from "react";
// import {HashRouter, Route, Router } from "react-router-dom";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
  withRouter
} from "react-router-dom";
import service from "./services";
import Loader from '../src/component/loader'
//Redux Connect
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { ActCreators } from "./redux/bindActionCretor";

import history from "./history";
import { globalLogout } from "./utils/auth";

import SignIn from "./authLayout/signIn";
import SignUp from "./authLayout/signUp";
import ResetPassword from "./authLayout/resetPassword";
import ForgetPassword from "./authLayout/forgetPassword";
// private screening
import PSSignIn from "./authLayout/privateScreening/signIn";
import PSSignUp from "./authLayout/privateScreening/signUp";
import PSResetPassword from "./authLayout/privateScreening/resetPassword";
import PSForgetPassword from "./authLayout/privateScreening/forgetPassword";

import SuperAdminAccessManagement from "./component/superAdminAccessMgnt";
import SuperAdminUserManagement from "./component/superAdminUserMgnt";
import AdminDashhboard from "./component/adminDashboard";
import PartnersView from "./component/partners/partnerViewEvent";
import ArtistsView from "./component/artistsView";
import partnersAdminView from "./component/partners/partnersAdminView";
import profilePartnerView from "./component/partners/profilePartnerView";
import PartnerEventAdminView from "./component/partners/PartnerEventAdminView";
import PartnersEvent from "./component/partners/partnerViewEvent";
import VillegeHomePage from "./component/partners/VillageHomePage";
import ArtistList from "./component/artists/artistEventList";
import ArtistView from "./component/artists/artistEventView";
import ArtistsPage from './component/artists/ArtistsPage';
import AddPartnersEvent from "./pages/addPartnerEvent";
import FpgFilmList from './pages/fpgfilmlist';
// fpg admin

import FpgAdminDetailView from './pages/FpgFilmDetailView';
import FpgCreateFilm from './pages/fpgfilmcreate';
import FilmCategory from './pages/FilmCategory';
import AwardCategory from './pages/AwardCategory';
import ScreeningTypes from './pages/ScreeningTypes';
import FilmGenre from './pages/FilmGenre';
import FilminterestTracks from "./pages/FilminterestTracks";
import Filmaccessibillity from "./pages/Filmaccessibillity";
import FilmCreditLebel from "./pages/FilmCreditLebel";
import NewFrontierCreditLabel from "./pages/NewfrontierCreditLabel";
// import FilmInterestTrack from './pages/filminteresttrack';
import TALKEVENTSAccessiblity from "./pages/TALK&EVENTSAccessiblity";
import OTHEREVENTSAccessiblity from "./pages/OTHEREVENTSAccessiblity";
import TALKEVENTSCategory from "./pages/TALK&EVENTSCategory";
import OTHEREVENTSCategory from "./pages/OTHEREVENTSCategory";
import EventSponsors from "./pages/EventSponsors";
import TALKEVENTSGenre from "./pages/TALK&EVENTSGenre";

import NotFound from "./pages/not-found";
import PrivateRoutes from "./privateRoutes";

// import HomePageCms from "./pages/HomePageCms";
// import AddSponsors from "./pages/AddSponsors";
// import ProgramCreate from "./component/fpg/create/ProgramCreate";
// import ProgramView from "./component/fpg/view/ProgramView";
// import NewFrontierAccessiblity from "./pages/NewFrontierAccessiblity";
// import NewFrontierCategory from "./pages/NewFrontierCategory";
// import ShortProgram from "./pages/ShortProgram";
// import PrivateEvents from "./pages/PrivateEvents";
// import AddPrivateEvents from "./pages/AddPrivateEvents";

import Ticketing from "./pages/ticketing";
import Benefits from "./pages/benefits";
import HeaderFooterDate from "./pages/headerFooterDate";


import ProductCouponList from './pages/productcouponlist';
import productstoreupsell from './pages/productstoreupsell';
import ProductDetail from './pages/productdetail';
import ProductStoreDetail from './pages/productstoredetail';
import Couponlist from './pages/couponslist';
import CouponDetail from './pages/coupondetail';
import ProductMemberlist from './pages/ProductMemberlist';
import ProductMemberDetail from './pages/ProductMemberDetail';
// import FestHeader from './pages/howtofest/header'
// import FestPlateform from './pages/howtofest/exploreplatform'
// import GetSetup from './pages/howtofest/getsetup';
// import Accessibility from './pages/howtofest/accessibility';
// import HowToWatch from './pages/howtofest/howtowatch';
// import AttendInPerson from './pages/howtofest/attendperson';
// import Tips from './pages/howtofest/tips';
// import JoinConversation from './pages/howtofest/joinconversation';
// import FestFooter from './pages/howtofest/footer'

import Aboutsundance from './pages/aboutsundance'
import FestivalHelp from './pages/festivalhelp'
import HomePageCms from "./pages/HomePageCms";
import AddSponsors from "./pages/AddSponsors";
import ProgramCreate from "./component/fpg/create/ProgramCreate";
import EpisodicProgramCreate from "./component/fpg/create/EpisodicProgramCreate";
import ProgramView from "./component/fpg/view/ProgramView";
import EpisodicProgramView from "./component/fpg/view/EpisodicProgramView";
import NewFrontierAccessiblity from "./pages/NewFrontierAccessiblity";
import NewFrontierCategory from "./pages/NewFrontierCategory";
import ShortProgram from "./pages/ShortProgram";
import PrivateEvents from "./pages/PrivateEvents";
import AddPrivateEvents from "./pages/AddPrivateEvents";

import Partneradminlist from './pages/privatescreening/partneradmin'
import PartnerspatnersFilmView from './pages/privatescreening/PartnerspatnersFilmView'
import PartnersProfileView from './pages/privatescreening/PartnersProfileView'
import PartnersFilmViewDetail from './pages/privatescreening/PartnersFilmViewDetail'
import EditFilmDetail from './pages/privatescreening/PartnersEditDetail'
import PartnerspatnersScreenings from './pages/privatescreening/PartnerspatnersScreenings'
import PartnersEditScreenings from './pages/privatescreening/PartnersEditScreenings'
import CreateFilm from './pages/privatescreening/CreateFilm'
import PartnerUserActivities from './pages/privatescreening/PartnerUserActivities'
import Home from './pages/Home'
import Highlights from './pages/highlights'
import FestTimeHome from './pages/FestTimeHome'
import HighlightsFh from './pages/highlightsFh'
import HighlightsTag from './pages/highlightsTag'
import HighlightDetailView from './pages/highlightDetailView'
import CreateHighLight from './pages/createHighLight'
import MsPartner from "./component/partners/MsPartner";
import DailySpeacials from "./component/partners/dailySpecials";
//Satellite Screens
import SatellitesView from './component/satellite/satellitesViewEvent'
import profileSatelliteView from './component/satellite/profileSatelliteView'
import satellitesAdminView from './component/satellite/satellitesAdminView'
import satelliteScreen from './component/satellite/satelliteScreen'
import SateliteEventView from "./component/satellite/sateliteEventView";
import UserActivities from './component/UserActivities';

import Screening from './pages/Screening'
import FestHeader from "./pages/howtofestPerson/header";
import GettingAround from "./pages/howtofestPerson/gettingAround";
import Venue from "./pages/howtofestPerson/venue";
import BoxOffice from "./pages/howtofestPerson/boxOffice";
import FestivalStore from "./pages/howtofestPerson/festivalStore";
import Accessibility from "./pages/howtofestPerson/accessibility";
import HealthAndWellness from "./pages/howtofestPerson/healthAndWellness";
import SafetyAndBelonging from "./pages/howtofestPerson/safetyAndBelonging";
import MoreInfo from "./pages/howtofestPerson/moreInfo";
// import FestFooter from "./pages/howtofestPerson/footer";

import FestHeaderOnline from "./pages/howtofestOnline/header1";
import TicketsAndRedemption from "./pages/howtofestOnline/ticketAndRedemption";
import HowToWatch from "./pages/howtofestOnline/howToWatch";
import CheckYourTech from "./pages/howtofestOnline/checkYourTech";
import AccessibilityOnline from "./pages/howtofestOnline/accessibility1";
import HealthAndWellnessOnline from "./pages/howtofestOnline/healthAndWellness1";
import SafetyAndBelongingOnline from "./pages/howtofestOnline/safetyAndBelonging1";
import MoreInfoOnline from "./pages/howtofestOnline/moreInfo1";
// import CommunityInterest from "./component/CommunityInterest";
// import FestFooterOnline from "./pages/howtofestOnline/footer1";


// PAF Start

import PostAcceptanceList from "./pages/paf/PostAcceptanceList";
import PafProject from "./pages/paf/PafProjectCreate";
import PafFilmCredit from "./pages/paf/PafFilmCredit";
import PafNewfrontierCredit from "./pages/paf/PafNewfrontierCredit";
import PafFilmCategory from "./pages/paf/PafFilmCategory";
import PafNewfrontierCategory from "./pages/paf/PafNewfrontierCategory";
import PafView from "./pages/paf/view/PafView";

// PAF END

import FilmDevice from "./pages/FilmDevice";

import Locations from './pages/locations/locationslist';
import LandingPage from './pages/LandingPage';


import LocationDetail from './pages/locations/LocationDetail';
import LocationCreate from './pages/locations/createLocations';


import VenueType from './pages/reference/VenueType';
import VenueAccessibility from './pages/reference/Accessibility';
import Amenities from './pages/reference/Amenities';
import MobileAppNotification from "./pages/MobileAppNotification";
import MobileCreate from "./component/Mobile/MobileCreate";
import AppConfiguration from "./pages/AppConfiguration";
import MobileView from "./component/Mobile/MobileView";
import HomePageQuickLinks from "./pages/HomePageQuickLinks";
import CommunityInterest from "./component/CommunityInterest";
import EmailList from "./pages/EmailList";
import EmailDetail from "./pages/EmailDetail";
import WaitlistList from "./pages/WaitlistList";
import WaitlistListDetail from "./pages/WaitlistListDetail";
import MyWaitlists from "./pages/MyWaitlists";

// Page Takeover
import PageTakeoverList from './pages/pageTakeover/PageTakeoverList';
import ArchivesPage from './pages/ArchivesPage';
import PageTakeoverCreate from './pages/pageTakeover/PageTakeoverCreate';
import PageTakeoverView from './pages/pageTakeover/PageTakeoverView';
import PageTakeoverPreview from './pages/pageTakeover/PageTakeoverPreview';
// import RequestHandler from "./component/privatescreening/RequestHandler";

import AccessControlledPagesList from './pages/accessControlledPages/AccessControlledPagesList';
import AccessControlledPageDetail from './pages/accessControlledPages/AccessControlledPageDetail';



export const AuthContext = React.createContext({});
let sub;
const mapStateToProps = state => ({
  getBackToAdminPreviousPath: state.getBackToAdminPreviousPath,
  getLoginAdminByID:state.getLoginAdminByID,
  profileName: state.profileName
});

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ActCreators, dispatch);
};

class Routers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSocketConnected: false,
      isAuthenticated: false,
      isLoading: true,
    };
    this.apiserve = new service();
  }

  componentWillMount = () => {
    if (sessionStorage.getItem('reAuth')) {
      sessionStorage.removeItem('reAuth')
    }
    this.apiserve.connect((flag) => {
      if (flag) {
        this.setState({ isSocketConnected: true }, () => {
          if(this.props.getLoginAdminByID && ((localStorage.getItem('currentUserRole') && localStorage.getItem('currentUserRole') !== null) && (localStorage.getItem('loginToken') && localStorage.getItem('loginToken') !== null))){
            setTimeout(() => {
              this.apiserve.sendevent("getUser", { id: this.props.getLoginAdminByID });
            }, 1000);
          }          

          var userRole = localStorage.getItem('currentUserRole')

          var token = '';
          // if(userRole === 'admin')
          // {
          token = localStorage.getItem('loginToken') ? localStorage.getItem('loginToken') : ''
          // }
          // else
          // {
          //   token = localStorage.getItem('subloginToken') ? localStorage.getItem('subloginToken') : ''
          // }

          if (token === null || token === 'null' || token === undefined || token === 'undefined' || token === '') {
            if (window.location.pathname.includes('/ps-register') ||
              window.location.pathname.includes('/ps-signin') ||
              window.location.pathname.includes('/ps-reset') ||
              window.location.pathname.includes('/ps-forget') ||
              window.location.pathname.includes('/register') ||
              window.location.pathname.includes('/reset') ||
              window.location.pathname.includes('/forget')) {
            } else {
              this.props.history.push('/')
            }
            this.setState({ isLoading: false });
            return false
          } else {
            if((localStorage.getItem('currentUserRole') && localStorage.getItem('currentUserRole') !== null) && (localStorage.getItem('loginToken') && localStorage.getItem('loginToken') !== null)){
              this.apiserve.sendevent("authentication", { token: token, role:localStorage.getItem('currentUserRole') });
            } else {
              this.logOut()
            }
          }
        })
      }
    });
    
    this.apiserve.sendevent("location|getCountryList", {});
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "authentication":
          if(!response.error){
            this.setState({ isAuthenticated: true, isLoading: false }, () => {
              // this.props.history.push('/access-management')
            })
          } else {
            this.logOut()
          }
          break;
        case "registerUser":
          this.setState({
            isAuthenticated: true
          }, () => {
            if (response.data.token) {
              let data = response.data;
              localStorage.setItem('loginToken', response.data.token)
              localStorage.setItem('currentUserRole', data.user.role)
              this.props.LoginToken(response.data.token)
              this.props.LoginRole(data)
              this.props.LoginAdminByID(response.data.user._id)
              setTimeout(() => {
                this.setState({ btnDisable: false, loaderFlag: false })
                this.apiserve.success("Login successful.")
                if (data.user.role === "sio" ||
                  data.user.role === "press" ||
                  data.user.role === "sundanceCircle" ||
                  data.user.role === "sundanceGuest" ||
                  data.user.role === "general" ||
                  data.user.role === "artist") {
                  this.props.history.push('/admin-dashboard')
                } else if (data.user.role === "partner") {
                  this.props.GetPartner(response.data)
                  this.props.history.push('/profile-partner-view')
                }
                else if (data.user.role === "privateScreeningPartner") {
                  if (this.state.mount)
                    this.props.history.push('/partners-list')
                  else this.setState({ mount: true });
                }
                else if (data.user.role === "satellite") {
                  if (this.state.mount)
                    this.props.history.push('/profile-satellite-view')
                  else this.setState({ mount: true });
                }
                else {
                  if (this.props.getBackToAdminPreviousPath === 'privateScreeningPartner') {
                    this.props.history.push('/partners-list')
                    this.props.BackToAdminPreviousPath('')
                  }
                  else if (this.props.getBackToAdminPreviousPath === 'partner') {
                    this.props.history.push('/partners-view')
                    this.props.BackToAdminPreviousPath('')
                  } else if (this.props.getBackToAdminPreviousPath === 'satellite') {
                    this.props.history.push('/satellites-view')
                    this.props.BackToAdminPreviousPath('')
                  } else {
                    this.props.history.push('/access-management')
                  }
                }
                this.apiserve.sendevent("getUser", { id: response.data.user._id });
              }, 1000)
            } else {
              this.setState({ loaderFlag: false })
              this.apiserve.error(response.data.error ? response.data.error : response.data)
            }
          })
          break;
        case 'privateScreeningPartner|cms|login':
        case "privateScreeningPartner|cms|register":
          this.setState({
            isAuthenticated: true
          }, () => {
            if (response.data.token) {
              localStorage.setItem('loginToken', response.data.token)
              localStorage.setItem('currentUserRole', response.data.user.role)

              this.props.LoginToken(response.data.token)
              this.props.LoginRole(response.data)
              this.props.LoginAdminByID(response.data.user._id)
              setTimeout(() => {
                this.setState({ btnDisable: false, loaderFlag: false })
                this.apiserve.success("Login successful.")
              }, 0)
              this.apiserve.sendevent("privateScreeningPartner|getById", { id: response.data.user._id });
            } else {
              this.setState({ loaderFlag: false })
              this.apiserve.error(response.data.error ? response.data.error : response.data)
            }
          })
          break;

        case "getUser":
          var newKey = response.data.forceLogoutKey;
          var oldKey = this.props.profileName.forceLogoutKey;
          if((oldKey && (newKey !== oldKey)) && (response.data.additionalRoles.every((val, i) => val === this.props.profileName.additionalRoles[i]))){
            this.logOut('FORCE')
          }
          if(!response.error){
            this.props.ProfileName(response.data)
          }
          break;
        case "privateScreeningPartner|getById":
          if (!response.error) {
            this.props.ProfileName(response.data);
            this.props.history.push('/');
            this.props.history.push('/partners-film-view')
          }
          break;
        case "location|getCountryList":
          if (!response.error) {
            this.props.Countries(response.data);
          }
          break;
      }
    })
  }

  logOut = (TYPE) => {
    globalLogout(this.props.history, TYPE);
  }

  componentWillUnmount = () => {
    sub.unsubscribe();
  }

  render() {
    return (
      <>

      <AuthContext.Provider
        value={{
          isAuthenticated: this.state.isAuthenticated,
          isLoading: this.state.isLoading,
          isRoute: this.state.ro
        }}
      >


        {this.state.isSocketConnected ?
          <Switch>
            <Route
              exact
              path="/"
              render={(props) => <SignIn {...props} SignIn={this.SignIn} />}
            />

            <Route
              exact
              path="/register"
              render={(props) => <SignUp {...props} SignUp={this.SignUp} />}
            />

            <Route
              exact
              path="/reset"
              render={(props) => <ResetPassword {...props} ResetPassword={this.ResetPassword} />}
            />

            <Route
              exact
              path="/forget"
              render={(props) => <ForgetPassword {...props} ForgetPassword={this.ForgetPassword} />}
            />

            {/* private screening route */}
            <Route
              exact
              path="/ps-signin"
              render={(props) => <PSSignIn {...props} PSSignIn={this.PSSignIn} />}
            />

            <Route
              exact
              path="/ps-register"
              render={(props) => <PSSignUp {...props} PSSignUp={this.PSSignUp} />}
            />

            <Route
              exact
              path="/ps-reset"
              render={(props) => <PSResetPassword {...props} PSResetPassword={this.PSResetPassword} />}
            />

            <Route
              exact
              path="/ps-forget"
              render={(props) => <PSForgetPassword {...props} PSForgetPassword={this.PSForgetPassword} />}
            />
            {/* <Route
                exact
                path="/home-page-cms"
                render={(props) => <HomePageCms {...props} HomePageCms={this.HomePageCms} />}
              /> */}

            <PrivateRoutes exact path="/home-page-cms" component={HomePageCms} />
            <PrivateRoutes exact path="/add-sponsors" component={AddSponsors} />
            <PrivateRoutes exact path="/home" component={Home} />
            {/* <PrivateRoutes exact path="/add-sponsors" component={AddSponsors} /> */}
            <PrivateRoutes exact path="/film/:filmEditId?" component={FpgAdminDetailView} />
            <PrivateRoutes exact path="/create-film" component={FpgCreateFilm} />
            <PrivateRoutes exact path="/create-film/:filmEditId?/edit" component={FpgCreateFilm} />
            <PrivateRoutes exact path="/filmlist/:filmEditId?" component={FpgFilmList} />
            <PrivateRoutes exact path="/filmcategory" component={FilmCategory} />
            <PrivateRoutes exact path="/awardcategory" component={AwardCategory} />
            <PrivateRoutes exact path="/screeningtype" component={ScreeningTypes} />
            <PrivateRoutes exact path="/filmgenre" component={FilmGenre} />
            <PrivateRoutes exact path="/eventsgenre" component={TALKEVENTSGenre} />
            <PrivateRoutes exact path="/program" component={ProgramCreate} />
            <PrivateRoutes exact path="/episodic-program" component={EpisodicProgramCreate} />
            <PrivateRoutes exact path="/program-view" component={ProgramView} />
            <PrivateRoutes exact path="/episodic-program-view" component={EpisodicProgramView} />
            <PrivateRoutes exact path="/mobile-view" component={MobileView} />
            <PrivateRoutes exact path="/short-program-list" component={ShortProgram} />

            <PrivateRoutes exact path="/filminterest" component={FilminterestTracks} />
            <PrivateRoutes exact path="/newfrontierdevice" component={FilmDevice} />
            <PrivateRoutes exact path="/filmaccessibillity" component={Filmaccessibillity} />
            <PrivateRoutes exact path="/filmcreditlebel" component={FilmCreditLebel} />
            <PrivateRoutes exact path="/new-frontier-creditlebel" component={NewFrontierCreditLabel} />
            <PrivateRoutes exact path="/eventcategory" component={TALKEVENTSCategory} />
            <PrivateRoutes exact path="/othereventscategory" component={OTHEREVENTSCategory} />
            <PrivateRoutes exact path="/event-sponsors" component={EventSponsors} />
            <PrivateRoutes exact path="/talkeventsaccessiblity" component={TALKEVENTSAccessiblity} />
            <PrivateRoutes exact path="/eventsaccessiblity" component={TALKEVENTSAccessiblity} />
            <PrivateRoutes exact path="/othereventsaccessiblity" component={OTHEREVENTSAccessiblity} />
            <PrivateRoutes exact path="/newfrontieraccessiblity" component={NewFrontierAccessiblity} />
            <PrivateRoutes exact path="/newfrontiercategory" component={NewFrontierCategory} />

            <PrivateRoutes exact path="/access-management" component={SuperAdminAccessManagement} />
            <PrivateRoutes exact path="/user-management" component={SuperAdminUserManagement} />
            <PrivateRoutes exact path="/admin-dashboard" component={AdminDashhboard} />
            <PrivateRoutes exact path="/partners-view" component={PartnersView} />
            {/* <PrivateRoutes exact path="/user-activities" component={UserActivities} /> */}
            {/* <PrivateRoutes exact path="/partners-view" component={PartnersView} /> */}
            {/* <PrivateRoutes exact path="/artists-view" component={ArtistsView} /> */}
            <PrivateRoutes exact path="/partners-event" component={PartnersEvent} />
            {/* <PrivateRoutes exact path="/add-event" component={AddPartnersEvent} /> */}
            <PrivateRoutes exact path="/partner-adminview" component={partnersAdminView} />
            <PrivateRoutes exact path="/ms-partner-page" component={MsPartner} />
            <PrivateRoutes exact path="/daily-specials" component={DailySpeacials} />
            <PrivateRoutes exact path="/partner-event-adminview" component={PartnerEventAdminView} />
            <PrivateRoutes exact path="/profile-partner-view" component={profilePartnerView} />
            <PrivateRoutes exact path="/villege-home-page" component={VillegeHomePage} />
            <PrivateRoutes exact path="/satellites-view" component={SatellitesView} />
            <PrivateRoutes exact path="/satellites-event-view" component={SateliteEventView} />

            <PrivateRoutes exact path="/profile-satellite-view" component={profileSatelliteView} />
            <PrivateRoutes exact path="/satellite-adminview" component={satellitesAdminView} />
            <PrivateRoutes exact path="/satellite-page" component={satelliteScreen} />
            <PrivateRoutes exact path="/artist-event-list" component={ArtistList} />
            <PrivateRoutes exact path="/artist-event-view" component={ArtistView} />
            <PrivateRoutes exact path="/artist-page" component={ArtistsPage} />
            {/* <PrivateRoutes exact path="/private-events-list" component={PrivateEvents} /> */}
            {/* <PrivateRoutes exact path="/add-private-events" component={AddPrivateEvents} /> */}
            <PrivateRoutes exact path="/ticketing" component={Ticketing} />
            <PrivateRoutes exact path="/benefits" component={Benefits} />
            <PrivateRoutes exact path="/Header-footer-date" component={HeaderFooterDate} />
            <PrivateRoutes exact path="/homepage" component={HomePageQuickLinks} />
            <PrivateRoutes exact path="/app-configuration" component={AppConfiguration} />
            <PrivateRoutes exact path="/notifications" component={MobileAppNotification} />
            <PrivateRoutes exact path="/notification-create" component={MobileCreate} />

            <PrivateRoutes exact path="/product-list" component={ProductCouponList} />
            <PrivateRoutes exact path="/store-listupsell-product" component={productstoreupsell} />
            <PrivateRoutes exact path="/product-detail" component={ProductDetail} />
            <PrivateRoutes exact path="/product-store-detail" component={ProductStoreDetail} />
            <PrivateRoutes exact path="/discounts-list" component={Couponlist} />
            <PrivateRoutes exact path="/discount-detail" component={CouponDetail} />
            <PrivateRoutes exact path="/member-list" component={ProductMemberlist} />
            <PrivateRoutes exact path="/member-detail" component={ProductMemberDetail} />


            {/* <PrivateRoutes exact path="/fest-header" component={FestHeader} /> */}
            {/* <PrivateRoutes exact path="/fest-plateform" component={FestPlateform} /> */}
            {/* <PrivateRoutes exact path="/setup" component={GetSetup} /> */}
            {/* <PrivateRoutes exact path="/accessibility" component={Accessibility} /> */}
            {/* <PrivateRoutes exact path="/fest-footer" component={FestFooter} /> */}

            <PrivateRoutes exact path="/fest-header-inPerson" component={FestHeader} />
            <PrivateRoutes exact path="/fest-getting-around" component={GettingAround} />
            <PrivateRoutes exact path="/venue" component={Venue} />
            <PrivateRoutes exact path="/fest-tickets" component={BoxOffice} />
            <PrivateRoutes exact path="/festival-store" component={FestivalStore} />
            <PrivateRoutes exact path="/accessibility-inPerson" component={Accessibility} />
            <PrivateRoutes exact path="/COVID-19" component={HealthAndWellness} />
            <PrivateRoutes exact path="/safety-belonging-inPerson" component={SafetyAndBelonging} />
            <PrivateRoutes exact path="/FAQ-inPerson" component={MoreInfo} />
            {/* <PrivateRoutes exact path="/fest-footer-inPerson" component={FestFooter} /> */}

            <PrivateRoutes exact path="/fest-header-online" component={FestHeaderOnline} />
            <PrivateRoutes exact path="/tickets-redemptions" component={TicketsAndRedemption} />
            <PrivateRoutes exact path="/watch" component={HowToWatch} />
            <PrivateRoutes exact path="/check-your-tech" component={CheckYourTech} />
            <PrivateRoutes exact path="/accessibility-online" component={AccessibilityOnline} />
            {/* <PrivateRoutes exact path="/health-wellness-online" component={HealthAndWellnessOnline} /> */}
            <PrivateRoutes exact path="/safety-belonging-online" component={SafetyAndBelongingOnline} />
            <PrivateRoutes exact path="/FAQ-online" component={MoreInfoOnline} />
            {/* <PrivateRoutes exact path="/fest-footer-online" component={FestFooterOnline} /> */}


            {/* <PrivateRoutes exact path="/about-sundance" component={Aboutsundance} /> */}
            <PrivateRoutes exact path="/festival-help" component={FestivalHelp} />
            <PrivateRoutes exact path="/home" component={Home} />

            <PrivateRoutes exact path="/highlights" component={Highlights} />
            <PrivateRoutes exact path="/highlightfh" component={HighlightsFh} />
            <PrivateRoutes exact path="/highlight-tag" component={HighlightsTag} />
            <PrivateRoutes exact path="/highlight-detail-view" component={HighlightDetailView} />
            <PrivateRoutes exact path="/create-highlight" component={CreateHighLight} />
            <PrivateRoutes exact path="/fest-time-home" component={FestTimeHome} />


            {/* <PrivateRoutes exact path="/watch" component={HowToWatch} /> */}
            {/* <PrivateRoutes exact path="/person" component={AttendInPerson} /> */}
            {/* <PrivateRoutes exact path="/tips" component={Tips} /> */}
            {/* <PrivateRoutes exact path="/conversation" component={JoinConversation} /> */}
            {/* <PrivateRoutes exact path="/private-events-list" component={PrivateEvents} /> */}
            <PrivateRoutes exact path="/add-private-events" component={AddPrivateEvents} />
            {/* <PrivateRoutes exact path="/private-events-list" component={PrivateEvents} /> */}
            {/* <PrivateRoutes exact path="/add-private-events" component={AddPrivateEvents} /> */}

            <PrivateRoutes exact path="/screening" component={Screening} />



            <PrivateRoutes exact path="/partners-list" component={Partneradminlist} />
            <PrivateRoutes exact path="/partners-profile" component={PartnersProfileView} />
            <PrivateRoutes exact path="/partners-film-view" component={PartnerspatnersFilmView} />
            <PrivateRoutes exact path="/partner-film-detail-view/:id" component={PartnersFilmViewDetail} />
            <PrivateRoutes exact path="/partner-edit-view/:id" component={EditFilmDetail} />
            <PrivateRoutes exact path="/partner-screening-list" component={PartnerspatnersScreenings} />
            <PrivateRoutes exact path="/partner-edit-screening/:id" component={PartnersEditScreenings} />
            <PrivateRoutes exact path="/partner-add-screening" component={PartnersEditScreenings} />
            <PrivateRoutes exact path="/create-private-film" component={CreateFilm} />
            <PrivateRoutes exact path="/edit-private-film/:id" component={CreateFilm} />
            <PrivateRoutes exact path="/partner-user-activities" component={PartnerUserActivities} />
            <PrivateRoutes exact path="/Community-Interests" component={CommunityInterest} />



            {/* PAF Start */}
            <PrivateRoutes exact path="/paf-projectlist/:PostAcceptanceEditListId?" component={PostAcceptanceList} />
            <PrivateRoutes exact path="/paf-project/:PostAcceptanceEditListId?/Edit" component={PafProject} />
            <PrivateRoutes exact path="/project-film-credit-label" component={PafFilmCredit} />
            <PrivateRoutes exact path="/project-nf-credit-label" component={PafNewfrontierCredit} />
            <PrivateRoutes exact path="/project-film-category" component={PafFilmCategory} />
            <PrivateRoutes exact path="/project-nf-category" component={PafNewfrontierCategory} />
            <PrivateRoutes exact path="/paf-projects/:PostAcceptanceEditListId?" component={PafView} />
            {/* PAF End */}
            <PrivateRoutes exact path="/locations/:locationEditId?" component={Locations} />
            <PrivateRoutes exact path="/Landing-Page" component={LandingPage} />

            <PrivateRoutes exact path="/location/:locationEditId?" component={LocationDetail} />
            <PrivateRoutes exact path="/create-location" component={LocationCreate} />
            <PrivateRoutes exact path="/create-location/:locationEditId?/Edit" component={LocationCreate} />

            {/* Page Takeover */}
            <PrivateRoutes exact path="/page-takeover-list" component={PageTakeoverList} />
            <PrivateRoutes exact path="/create-page-takeover" component={PageTakeoverCreate} />
            <PrivateRoutes exact path="/page-takeover-view/:pageTakeoverEditId?" component={PageTakeoverView} />
            <PrivateRoutes exact path="/create-page-takeover/:pageTakeoverEditId?/edit" component={PageTakeoverCreate} />
            <PrivateRoutes exact path="/page-takeover-preview" component={PageTakeoverPreview} />

            <PrivateRoutes exact path="/venue-type" component={VenueType} />
            <PrivateRoutes exact path="/location-accessibility" component={VenueAccessibility} />
            <PrivateRoutes exact path="/amenities" component={Amenities} />
            <PrivateRoutes exact path="/email-list" component={EmailList} />
            <PrivateRoutes exact path="/email-detail" component={EmailDetail} />
            <PrivateRoutes exact path="/waitlist-management" component={WaitlistList} />
            <PrivateRoutes exact path="/my-waitlists" component={MyWaitlists} />
            <PrivateRoutes exact path="/waitlist-management/:screeningId?" component={WaitlistListDetail} />
            {/* <PrivateRoutes exact path="/eventive-play-token-check/:eventive?" component={RequestHandler} /> */}

            {/* Access Controlled Pages */}
            <PrivateRoutes exact path="/access-controlled-pages" component={AccessControlledPagesList} />
            <PrivateRoutes exact path="/access-controlled-pages/create" component={AccessControlledPageDetail} />
            <PrivateRoutes exact path="/access-controlled-pages/:recordId" component={AccessControlledPageDetail} />

            <PrivateRoutes exact path="/archives-page" component={ArchivesPage} />

            <Route path="*" component={NotFound} />

          </Switch>
          : ''}
      </AuthContext.Provider>
      </>


    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Routers));